export const INITIATE_PROPOSAL_RENEWAL_ACTIONS_LIST_TEST_ID = 'initiate-proposal-renewal-actions-list';
export const INITIATE_PROPOSAL_RENEWAL_ACTION_MORE_PRODUCT_LINES_TEST_ID =
  'initiate-proposal-renewal-action-more-product-lines';
